<div class="not-found-wrapper">
  <div class="mat-body">
    <p>
      Page not found.
    </p>
    <p></p>
    <p><a routerLink="/">Home</a></p>
    <p><a routerLink="/products">Database</a></p>
  </div>
</div>
